import { render } from "./EventRegistration.vue?vue&type=template&id=63a81228&scoped=true"
import script from "./EventRegistration.vue?vue&type=script&lang=js"
export * from "./EventRegistration.vue?vue&type=script&lang=js"

import "./EventRegistration.vue?vue&type=style&index=0&id=63a81228&scoped=true&lang=css"

import exportComponent from "/Users/jinming/Documents/jhapps-v2/packages/frontendscanning/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a81228"]])

export default __exports__